// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfcf8576","453":"98d784cb","455":"e086c86c","977":"82346643"}[chunkId] + ".chunk.js";
};